import { Action } from 'redux';

import { RemoveExternalContentAction } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';


export interface RemoveExternalContentAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'>;
}

export function removeExternalContentAction(item: IContentInfo<'database'> | IContentInfo<'table'>): RemoveExternalContentAction {
  return {
    type: RemoveExternalContentAction,
    item
  };
}
